module.exports = __webpack_public_path__ + "img/582.34217440.jpg";